module.exports = __webpack_public_path__ + "static/small-van-2078fb5b8ed7d2f498fccb79c3a52e62.jpg";